import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=afe5304e&scoped=true"
import script from "./joinUs.vue?vue&type=script&lang=js"
export * from "./joinUs.vue?vue&type=script&lang=js"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=afe5304e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe5304e",
  null
  
)

export default component.exports